import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { useTawkTo } from './hooks/useTawkTo';
import { useDocumentTitle } from './hooks/useDocumentTitle';
import { useGoogleTagManager } from './hooks/useGoogleTagManager';
import { business } from './data/business';
export function App() {
  useDocumentTitle(`${business.brand} — ${business.legalName}`);
  useGoogleTagManager();
  useTawkTo();
  return <BrowserRouter data-id="element-0" data-mp="2mnnhk7prei2v">
      <Routes data-id="element-1" data-mp="2mjzlp1wudjkz">
        <Route path="/" element={<Landing data-id="element-3" data-mp="31ayqe1uk3nza" />} data-id="element-2" data-mp="31aqh0jxn70su" />
        <Route path="/terminos-y-condiciones" element={<Terms data-id="element-5" data-mp="2wk0bn6p7uxy5" />} data-id="element-4" data-mp="31bi7xhgaoacs" />
        <Route path="/politica-de-privacidad" element={<Privacy data-id="element-7" data-mp="2wip7v6vrtq71" />} data-id="element-6" data-mp="2wjgq7g0cxrfd" />
        <Route path="*" element={<Landing data-id="element-9" data-mp="28tw5arkn8k3g" />} data-id="element-8" data-mp="2wi5qbra193tj" />
      </Routes>
    </BrowserRouter>;
}